import { FC, ReactNode } from "react";
import { Helmet } from "react-helmet";

interface Props {
    title: string;
    description: string;
    children: ReactNode;
}

const AuthLayout: FC<Props> = ({ title, description, children }) => {
    return (
        <div className="w-screen h-screen relative">
            <Helmet>
                <title>{title}</title>
            </Helmet>

            <img
                className="absolute bottom-0 right-0 w-48"
                src="/images/pattern-side.png"
                alt=""
            />

            <img
                className="absolute top-0 left-0 w-48"
                src="/images/pattern-two-side.png"
                alt=""
            />

            <div className="root-container flex items-center justify-center h-full w-full relative z-10">
                <section className="flex-1">
                    <main className="grid grid-cols-12">
                        <div className="col-span-12 sm:col-span-8 sm:col-start-3 md:col-span-6 md:col-start-4 lg:col-span-4 lg:col-start-5">
                            <div className="bg-white rounded-lg shadow-md px-4 py-6 mb-2">
                                <img
                                    src="/images/logo-dark.png"
                                    className="max-w-full mx-auto w-28 mb-10 block"
                                    alt="وینکا"
                                />

                                <h1 className="text-2xl font-bold mb-2 text-gray-700">
                                    {title}
                                </h1>

                                <p className="text-sm text-gray-600 mb-10">
                                    {description}
                                </p>

                                {children}
                            </div>
                        </div>
                    </main>
                </section>
            </div>
        </div>
    );
};

export default AuthLayout;
